import styled from '@emotion/styled';
import React, { JSX } from 'react';
import {
  BookedItemComponentProps,
  ItemComponentView,
  ItemRegistry
} from '../../../../Models/ItemRegistry';
import fallback from '../../../../_Translations/generated/booked-item-component.en.t.json';
import Keys from '../../../../_Translations/generated/booked-item-component.en.t.json.keys';
import useTranslation from '../../../Hooks/useTranslation';

type Props = {
  registry: ItemRegistry;
  view?: ItemComponentView;
};

const RegistryLookupFailed = styled.div`
  border: 3px solid #c90e0e;
  font-weight: bold;
  color: #c90e0e;
  padding: 12px;
`;

const BookedItemComponent = (props: BookedItemComponentProps & Props): JSX.Element => {
  const { t } = useTranslation('booked-item-component', fallback, Keys);
  const { item, view = ItemComponentView.SUMMARY, registry, children } = props;

  const { itemType } = item;

  if (Object.prototype.hasOwnProperty.call(registry, itemType)) {
    let Comp = registry[itemType]?.Cart;

    if (view === ItemComponentView.SUMMARY) {
      Comp = registry[itemType]?.Summary;
    }

    if (view === ItemComponentView.CHECKOUT) {
      Comp = registry[itemType]?.Checkout;
    }

    if (Comp) {
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Comp {...props}>{children}</Comp>
      );
    }
  }
  return <RegistryLookupFailed>{t(Keys.bookedItemComponent, { itemType })}</RegistryLookupFailed>;
};
export default BookedItemComponent;
